import { lazy } from 'react'

/**
 * Immersive Theme Configuration
 * Full-screen map experience for all pages
 */
const immersiveTheme = {
  id: 'immersive',
  name: 'Immersive',
  description: 'Full-screen map experience',
  icon: 'map',
  components: {
    Home: lazy(() => import('./immersive/ImmersiveHome.jsx')),
    EntityDetail: lazy(() => import('./immersive/ImmersiveEntityDetail.jsx')),
    Login: lazy(() => import('./immersive/ImmersiveLoginRedirect.jsx')),
    Register: lazy(() => import('./immersive/ImmersiveRegisterRedirect.jsx')),
  },
  showNavbar: false,
  showFooter: false,
  isImmersivePage: (pathname) => {
    return pathname === '/' 
      || pathname.startsWith('/entity/') 
      || pathname === '/login' 
      || pathname === '/register'
      || pathname.startsWith('/admin')
  },
}

/**
 * Get the immersive theme configuration
 * @returns {object} Immersive theme configuration
 */
export const getTheme = () => {
  return immersiveTheme
}

export default immersiveTheme
